import { apiClient } from './index.js';

async function getDialogs() {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/UserMessage/GetDialogs',
  });
  return data;
}

async function getMessageFromUser({ userId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/UserMessage/GetMessageFromUser',
    params: { UserId: userId },
  });
  return data;
}

export { getDialogs, getMessageFromUser };
